import React from 'react';
import ReactModal from '../Modal';
import { withTranslation } from 'react-i18next';
import Loading from '../Loading';

class ConfirmationModal extends React.Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <ReactModal modalState={this.props.isOpen} className="width-sm">
                <p>{this.props.message}</p>
                <div className="btn-wrapper">
                    <button
                        type="button"
                        className="button button-outline button-primary width-sm btn"
                        onClick={this.props.onClose}
                        style={{ lineHeight: 'unset' }}
                    >
                        {this.props.cancleBtn ?? t('confirmation_modal.cancel')}
                    </button>
                    <button
                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center gap-8"
                        onClick={this.props.onSubmit}
                        disabled={this.props.loading}
                    >
                        {this.props.loading && <Loading onlyPreloader />}
                        {this.props.buttonName}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(ConfirmationModal);
